"use client";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { PostingTemplateUpsertRequest } from "@chotca/config";
import { getSdk } from "../sdk";
import { qk } from "../query-keys";

export function usePostingTemplates(orgId: string | null | undefined) {
  return useQuery({
    queryKey: qk.postingTemplates.list(orgId ?? ""),
    queryFn: () => getSdk().postingTemplates.list(orgId!),
    enabled: !!orgId,
    staleTime: 60_000,
  });
}

export function useCreatePostingTemplate(orgId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: PostingTemplateUpsertRequest) =>
      getSdk().postingTemplates.create(orgId, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.postingTemplates.list(orgId) });
    },
  });
}

export function useUpdatePostingTemplate(orgId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (args: {
      templateId: string;
      body: PostingTemplateUpsertRequest;
    }) => getSdk().postingTemplates.update(orgId, args.templateId, args.body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.postingTemplates.list(orgId) });
    },
  });
}

export function useDeletePostingTemplate(orgId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (templateId: string) =>
      getSdk().postingTemplates.remove(orgId, templateId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.postingTemplates.list(orgId) });
    },
  });
}
